import { InjectionToken } from '@angular/core';
export const MY_ACCOUNT_ROUTE_PATH = new InjectionToken<string>('MY_ACCOUNT_ROUTE_PATH');
